import Constants from "../constants";
import axios from "axios";

const state = {
    loading: false,
    contactHistoryLoading: false,
    contactHistory: [],
    error: null,
};

const getters =  {
    contactHistory(state) {
        return state.contactHistory;
    },
    contactHistoryLoading(state) {
        return state.contactHistoryLoading;
    },
    loading(state) {
        return state.loading;
    },
    error(state) {
        return state.error;
    },
}


const mutations = {
    setContactHistory(state, payload) {
        state.contactHistory = payload;
    },
    setContactHistoryLoading(state, payload) {
        state.contactHistoryLoading = payload;
    },
    setLoading(state, payload) {
        state.loading = payload;
    },
    setError(state, payload) {
        state.error = payload;
    },
    clearError(state) {
        state.error=null;
    },
}

const actions = {
    addContactHistory({commit,dispatch}, payload) {
        commit('setContactHistoryLoading', true);
        commit('clearError');

        axios.post(Constants.apiBaseURL+'dashboard/users/contact-history', payload)
            .then(response => {
                // eslint-disable-next-line no-unused-vars
                let data = response['data']['data'];
                commit('setContactHistoryLoading', false);
                dispatch('loadContactHistory', payload.patient_id)
            })
            .catch(error => {
                commit('setError', error);
                commit('setContactHistoryLoading', false);
            });
    },

    loadContactHistory({commit}, userId) {
        this.contactHistory = undefined;
        commit('setContactHistoryLoading', true);

        axios.get(Constants.apiBaseURL+'dashboard/users/contact-history/'+userId, {})
            .then(response => {
                // eslint-disable-next-line no-unused-vars
                let contactHistory = response['data']['data'];
                commit('setContactHistoryLoading', false);
                commit('setContactHistory', contactHistory);
            })
            .catch(error => {
                commit('setContactHistoryLoading', false);
                commit('setContactHistory', null);
                commit('setError', error);
            });
    },

    clearError({commit}) {
        commit('clearError');
    },
}

export default {
    namespaced: true,
    state,
    getters, 
    mutations,
    actions
}

